import { useState } from "react";
import LegalLayout, { H2, P, PH } from "../LegalLayout";

export default function Widerrufsformular() {
  const [form, setForm] = useState({ produkt: "", bestellt: "", erhalten: "", name: "", adresse: "", email: "", grund: "" });
  const [copied, setCopied] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const widerrufsText = () =>
    `Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über den Kauf der folgenden Produkte:

Produkt(e): ${form.produkt || "[Produkt eintragen]"}
Bestellt am: ${form.bestellt || "[Datum]"}
Erhalten am: ${form.erhalten || "[Datum]"}

Name des/der Verbraucher(s): ${form.name || "[Name]"}
Adresse des/der Verbraucher(s): ${form.adresse || "[Adresse]"}
E-Mail: ${form.email || "[E-Mail]"}

${form.grund ? `Grund (freiwillig): ${form.grund}\n\n` : ""}
Datum und Unterschrift (nur bei Brief): ${new Date().toLocaleDateString("de-DE")}`;

  const submit = (e) => {
    e.preventDefault();
    const subject = `Widerruf Bestellung — ${form.produkt || "MAZARO"}`;
    const body = widerrufsText();
    window.location.href = `mailto:support@mazaro.de?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(widerrufsText());
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (e) {
      setCopied(false);
    }
  };

  const inputCls =
    "w-full bg-black/40 border border-white/15 px-4 py-3 text-sm text-white placeholder:text-white/30 outline-none focus:border-gold transition-colors";

  return (
    <LegalLayout title="Muster-Widerrufsformular">
      <P>
        Wenn du den Vertrag widerrufen willst, dann fülle dieses elektronische Formular aus und sende es ab — es öffnet
        deine E-Mail-App mit einer vorbereiteten Nachricht an support@mazaro.de. Alternativ kannst du den Text kopieren
        oder das offizielle Muster nutzen.
      </P>

      <form onSubmit={submit} className="space-y-4 mt-8" data-testid="widerruf-form">
        <input data-testid="widerruf-produkt" className={inputCls} placeholder="Produkt(e), die du widerrufst (z.B. APEX PRO 16 OZ — Obsidian Gold)" value={form.produkt} onChange={set("produkt")} />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-2">Bestellt am</span>
            <input data-testid="widerruf-bestellt" type="date" className={inputCls} value={form.bestellt} onChange={set("bestellt")} />
          </label>
          <label className="block">
            <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 block mb-2">Erhalten am</span>
            <input data-testid="widerruf-erhalten" type="date" className={inputCls} value={form.erhalten} onChange={set("erhalten")} />
          </label>
        </div>
        <input data-testid="widerruf-name" required className={inputCls} placeholder="Dein Name" value={form.name} onChange={set("name")} />
        <textarea data-testid="widerruf-adresse" required rows={3} className={inputCls} placeholder="Deine Adresse (Straße, PLZ, Ort)" value={form.adresse} onChange={set("adresse")} />
        <input data-testid="widerruf-email" type="email" required className={inputCls} placeholder="Deine E-Mail-Adresse" value={form.email} onChange={set("email")} />
        <textarea data-testid="widerruf-grund" rows={2} className={inputCls} placeholder="Grund (freiwillig)" value={form.grund} onChange={set("grund")} />

        <div className="flex flex-col sm:flex-row gap-3 pt-2">
          <button type="submit" data-testid="widerruf-submit" className="btn-gold flex-1 justify-center">
            Widerruf per E-Mail senden
          </button>
          <button type="button" data-testid="widerruf-copy" onClick={copy} className="btn-ghost flex-1 justify-center">
            {copied ? "Kopiert!" : "Text kopieren"}
          </button>
        </div>
      </form>

      <H2>Offizielles Muster</H2>
      <div className="border border-white/10 bg-panel p-5 sm:p-6 text-slate-300 text-sm leading-relaxed whitespace-pre-line" data-testid="widerruf-muster">
        {`An
[Unternehmer einfügen: Vor- und Nachname, Adresse — siehe Impressum]

Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf
der folgenden Produkte (*) / die Erbringung der folgenden Dienstleistung (*)

Bestellt am (*) / erhalten am (*)

Name des/der Verbraucher(s)
Adresse des/der Verbraucher(s)
Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)
Datum

(*) Unzutreffendes streichen`}
      </div>
      <PH>Die Unternehmensangaben im Muster automatisch aus dem Impressum befüllen, sobald diese stehen.</PH>
    </LegalLayout>
  );
}
